/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import { createSlice } from '@reduxjs/toolkit';

const init_state = {
	script_code: '',
	checked_fields: []
};

const GatedContentSlice = createSlice({
	name: 'gated_content',
	initialState: init_state,
	reducers: {
		setGatedContent: (state, action) => {
			state.checked_fields = action.payload.checked_fields || state.checked_fields;
			state.script_code = action.payload.script_code || state.script_code;
		}
	}
});

export const { setGatedContent } = GatedContentSlice.actions;
export default GatedContentSlice;
